import { RentalPortalViewingProfileWidgetApplicants } from '../RentalPortalViewingProfileWidgetApplicants'
import { RentalPortalViewingProfileWidgetCreated } from '../RentalPortalViewingProfileWidgetCreated'
import { RentalPortalViewingProfileWidgetListing } from '../RentalPortalViewingProfileWidgetListing'

function RentalPortalViewingProfileWidgetList() {
  return (
    <>
      <RentalPortalViewingProfileWidgetListing />
      <RentalPortalViewingProfileWidgetApplicants />
      <RentalPortalViewingProfileWidgetCreated />
    </>
  )
}

export default RentalPortalViewingProfileWidgetList
